var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"button",staticClass:"button-block",class:_vm.computedClasses,on:{"click":_vm.emitEvents}},[_c('span',{staticClass:"button-block__label"},[_vm._t("default")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"button-block__loader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }